var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.35 4.5C8.35 4.22386 8.12614 4 7.85 4H7.5C7.22386 4 7 4.22386 7 4.5V8.09397C7 8.28179 7.10527 8.45378 7.27253 8.53923L10.2687 10.0699C10.501 10.1885 10.7854 10.1088 10.922 9.88669L11.1065 9.587C11.2629 9.33276 11.1632 8.99896 10.8929 8.87224L8.63774 7.81491C8.46215 7.73258 8.35 7.55614 8.35 7.3622V4.5Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z","fill":"currentColor","key":1})]);
}

Time.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = Time;

Time.default = Time;
